/** Read every cursor page without silently truncating the matching result set. */
export async function collectPages<T>(
  read: (cursor: string) => Promise<{ items: readonly T[]; nextCursor?: string }>,
): Promise<{ items: T[] }> {
  const items: T[] = [];
  const seen = new Set<string>();
  let cursor = "";
  for (;;) {
    const page = await read(cursor);
    items.push(...page.items);
    const next = page.nextCursor;
    if (next === undefined || next === "") return { items };
    if (seen.has(next)) throw new Error("The server returned a repeated pagination cursor.");
    seen.add(next);
    cursor = next;
  }
}
